import React, { FC } from 'react'
import { Project } from 'src/api'
import { DynamicColumn, Table, TableProps as TablePropsInterface } from '../../ui'
import ProjectColumns from '../../columns/project'

interface ProjectListProps {
  loading?: boolean
  count?: number
  data?: Project[]
  projectSectionId?: number | null
  noResultText?: string
  showFooter?: boolean
  TableProps?: Omit<TablePropsInterface<Project>, 'loading' | 'data' | 'columns' | 'count'>
  columns?: DynamicColumn<Project>[]
}

export const ProjectList: FC<ProjectListProps> = ({ loading = false, data = [], projectSectionId = null, count = 0, noResultText, showFooter, TableProps, columns }) => {
  const defaultColumns: DynamicColumn<Project>[] = [
    ProjectColumns.Name,
    ProjectColumns.Location,
    ProjectColumns.ContractorName,
    ...(projectSectionId ? [ProjectColumns.ProjectSection(projectSectionId)] : []),
    ProjectColumns.UserName,
    ProjectColumns.ProjectTypeName,
    ProjectColumns.Size,
    ProjectColumns.ConnectedSensors
  ]

  return <Table {...TableProps} loading={loading} data={data} columns={columns || defaultColumns} count={count} noResultText={noResultText} showFooter={showFooter} />
}
